import React from 'react';
import './ReviewAnalyticsCard.css';

const ReviewAnalyticsCard = () => {
  const mostReviewedItems = [
    { name: 'Chicken Biryani', reviews: 234, rating: 4.8 },
    { name: 'Pizza', reviews: 189, rating: 4.6 },
    { name: 'Burger', reviews: 156, rating: 4.5 }
  ];

  return (
    <div className="review-analytics-card">
      <h3 className="analytics-title">Review Insights</h3>
      
      <div className="analytics-grid">
        <div className="analytics-column">
          <div className="analytics-label">MOST REVIEWED ITEMS</div>
          <div className="items-list">
            {mostReviewedItems.map((item, i) => (
              <div key={i} className="item-row">
                <span className="item-rank">{i + 1}.</span>
                <div className="item-info">
                  <div className="item-name">{item.name}</div>
                  <div className="item-stats">
                    {item.reviews} reviews ({item.rating}⭐)
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="analytics-column">
          <div className="analytics-label">RESPONSE RATE</div>
          <div className="response-rate-display">
            <div className="rate-number">87%</div>
            <div className="rate-subtext">Replied to 1,073 of 1,234 reviews</div>
            <div className="rate-progress-ring">
              <svg viewBox="0 0 100 100" className="ring-svg">
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  fill="none"
                  stroke="#E9ECEF"
                  strokeWidth="8"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  fill="none"
                  stroke="#2D6A4F"
                  strokeWidth="8"
                  strokeDasharray={`${2 * Math.PI * 40}`}
                  strokeDashoffset={`${2 * Math.PI * 40 * (1 - 0.87)}`}
                  strokeLinecap="round"
                  transform="rotate(-90 50 50)"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="analytics-column">
          <div className="analytics-label">AVG RESPONSE TIME</div>
          <div className="response-time-display">
            <div className="time-number">2.5 hours</div>
            <div className="time-subtext">Based on last 30 days</div>
            <div className="time-target">Target: &lt; 4 hours</div>
          </div>
        </div>

        <div className="analytics-column">
          <div className="analytics-label">30-DAY TREND</div>
          <div className="trend-display">
            <div className="trend-chart">
              <svg viewBox="0 0 200 60" className="mini-chart">
                <polyline
                  points="10,50 30,45 50,40 70,35 90,30 110,28 130,25 150,22 170,20 190,18"
                  fill="none"
                  stroke="#004E89"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className="trend-indicator positive">
              <span>↑</span> +15%
            </div>
            <div className="trend-text">More reviews this month</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewAnalyticsCard;

